import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import { setLoggedIn } from "../Actions";
import { connect } from "react-redux";
import { toast } from "react-hot-toast";

function firebaseErrorMessage(code) {
  const messages = {
    'auth/email-already-in-use': 'That email is already registered. Try logging in.',
    'auth/invalid-email': 'Please enter a valid email address.',
    'auth/weak-password': 'Password must be at least 6 characters.',
    'auth/operation-not-allowed': 'Email/password sign-in is not enabled — check Firebase Console → Authentication → Sign-in methods.',
    'auth/unauthorized-domain': 'This domain is not authorized in Firebase Console → Authentication → Settings → Authorized domains.',
    'auth/popup-closed-by-user': 'Sign-in popup was closed.',
    'auth/network-request-failed': 'Network error. Check your connection.',
    'permission-denied': 'Firestore permission denied — update your Firestore security rules in Firebase Console.',
  };
  return messages[code] || null;
}

const initialRegister = {
  first_name: "",
  last_name: "",
  email: "",
  password: "",
};

function Register(props) {
  const [newUser, setNewUser] = useState(initialRegister);
  const navigate = useNavigate();

  function handleChange(e) {
    setNewUser({
      ...newUser,
      [e.target.name]: e.target.value,
    });
  }

  const registerAndLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await createUserWithEmailAndPassword(auth, newUser.email, newUser.password);
      const uid = res.user.uid;
      await setDoc(doc(db, 'users', uid), {
        uid,
        first_name: newUser.first_name,
        last_name: newUser.last_name,
        email: newUser.email,
        profile_pic_url: '',
        city: '',
        state: '',
        country: '',
        bio: '',
      });
      localStorage.setItem("user_id", uid);
      props.setLoggedIn();
      toast.success("Registered successfully!");
      navigate("/dashboard");
    } catch (err) {
      console.error("Registration error:", err.code, err.message);
      const msg = firebaseErrorMessage(err.code) || err.message || "Registration failed.";
      toast.error(msg);
    }
    setNewUser(initialRegister);
  };

  async function registerWithGoogle() {
    try {
      const provider = new GoogleAuthProvider();
      const res = await signInWithPopup(auth, provider);
      const uid = res.user.uid;

      const userDocRef = doc(db, 'users', uid);
      const userDoc = await getDoc(userDocRef);
      if (!userDoc.exists()) {
        const displayName = res.user.displayName || '';
        const nameParts = displayName.split(' ');
        await setDoc(userDocRef, {
          uid,
          first_name: nameParts[0] || '',
          last_name: nameParts.slice(1).join(' ') || '',
          email: res.user.email || '',
          profile_pic_url: res.user.photoURL || '',
          city: '',
          state: '',
          country: '',
          bio: '',
        });
      }

      localStorage.setItem("user_id", uid);
      props.setLoggedIn();
      toast.success("Signed up with Google!");
      navigate("/dashboard");
    } catch (err) {
      console.error("Google sign-up error:", err.code, err.message);
      const msg = firebaseErrorMessage(err.code) || err.message || "Google sign-up failed.";
      toast.error(msg);
    }
  }

  return (
    <div>
      <br></br>
      <br></br>
      <br></br>
      <h2>Register</h2>
      <form onSubmit={registerAndLogin}>
        <input
          required
          id="first-name"
          name="first_name"
          type="text"
          placeholder="First Name"
          value={newUser.first_name}
          onChange={handleChange}
        />
        <br></br>
        <input
          required
          id="last-name"
          name="last_name"
          type="text"
          placeholder="Last Name"
          value={newUser.last_name}
          onChange={handleChange}
        />
        <br></br>
        <input
          required
          id="email"
          name="email"
          type="text"
          placeholder="Email"
          value={newUser.email}
          onChange={handleChange}
        />
        <br></br>
        <input
          required
          id="password"
          name="password"
          type="password"
          placeholder="Password"
          value={newUser.password}
          onChange={handleChange}
        />
        <br></br>
        <button id="login" type="submit">
          Register & Login
        </button>
      </form>

      <br />
      <p style={{margin: '10px 0'}}>— or —</p>
      <button
        type="button"
        onClick={registerWithGoogle}
        style={{
          backgroundColor: '#fff',
          border: '1px solid #ccc',
          borderRadius: '4px',
          padding: '10px 20px',
          cursor: 'pointer',
          fontSize: '15px',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <img
          src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
          alt="Google"
          style={{ width: '18px', height: '18px' }}
        />
        Sign up with Google
      </button>

      <p id="noaccount">
        Already have an account?
        <br></br>
        <Link className="link" to="/login">
          <h5 style={{textDecoration: 'underline'}}>Login Here</h5>
        </Link>
      </p>
      <br />
      <br />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    first_name: state.first_name,
    last_name: state.last_name,
    loggedIn: state.loggedIn,
  };
};

export default connect(mapStateToProps, { setLoggedIn })(Register);
